/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Asia_Tokyo2Inputs */

const he_timezone_asia_tokyo2 = /** @type {(inputs: Timezone_Asia_Tokyo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokyo`)
};

const en_timezone_asia_tokyo2 = /** @type {(inputs: Timezone_Asia_Tokyo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokyo`)
};

/**
* | output |
* | --- |
* | "Tokyo" |
*
* @param {Timezone_Asia_Tokyo2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_asia_tokyo2 = /** @type {((inputs?: Timezone_Asia_Tokyo2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Asia_Tokyo2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_asia_tokyo2(inputs)
	return en_timezone_asia_tokyo2(inputs)
});
export { timezone_asia_tokyo2 as "timezone_Asia_Tokyo" }